import { HeartIcon, IconFillColor, IconWrapper, Tooltip } from '@dreryk/react-components';

import { medicineSelectorTranslationKeys } from '../../../../../../translations';
import { useFavoriteMedicineCreateCommand } from '../shared/hooks/favoriteMedicine.hooks';

type FavoriteMedicineCreateIconProps = {
   readonly medicineId: number;
   readonly onSuccess?: VoidFunction;
};

export const FavoriteMedicineCreateIcon = (props: FavoriteMedicineCreateIconProps): JSX.Element => {
   const { execute: addFavoriteMedicine, loading: addFavoriteMedicineLoading } = useFavoriteMedicineCreateCommand(
      props.medicineId,
      props.onSuccess,
      props.onSuccess
   );

   const handleClick = (): void => {
      if (!addFavoriteMedicineLoading) {
         addFavoriteMedicine({});
      }
   };

   return (
      <Tooltip testId={'addFavoriteMedicine'} content={medicineSelectorTranslationKeys.table.addMedicineToFavorites}>
         <IconWrapper onClick={handleClick} fillColor={IconFillColor.PRIMARY_LIGHTER} testId={'addFavoriteMedicine'}>
            <HeartIcon />
         </IconWrapper>
      </Tooltip>
   );
};
